import { jsx as i } from "react/jsx-runtime";
import { useMemo as a } from "react";
import c from "clsx";
import '../../_assets/Skeleton.1XklMnik.css';const k = "_skeleton_7zjq2_49", d = "_lightBackground_7zjq2_54", l = "_shine_7zjq2_1", g = "_darkBackground_7zjq2_62", u = "_image_7zjq2_71", o = {
  skeleton: k,
  lightBackground: d,
  shine: l,
  darkBackground: g,
  image: u,
  "slide-in-out": "_slide-in-out_7zjq2_1",
  "fade-in-out": "_fade-in-out_7zjq2_1"
}, q = ({
  className: s,
  width: n,
  height: t,
  children: r,
  variant: e = "light"
}) => {
  const _ = a(
    () => ({
      width: n,
      height: t
    }),
    [t, n]
  );
  return /* @__PURE__ */ i(
    "div",
    {
      className: c(o.skeleton, s, {
        [o.lightBackground]: e === "light",
        [o.darkBackground]: e === "dark"
      }),
      style: _,
      children: r
    }
  );
};
export {
  q as Skeleton
};
